export default "__VITE_ASSET__tMqbNdYr__"